$.fn.carousel = function( options ) {
	var carousel = this;
	var intervalCarousel;
	var settings = $.extend({
		playtime: 3000,
		slidemenu: false,
      	overlayObj: false 
	}, options );

	var galeryGoTo = function(index){
        var next = carousel.find('.item:eq('+index+')');

        carousel.find('.item.active').fadeOut(800, function(){
            $(this).removeClass('active');
        });
      
        next.fadeIn(800, function(){
            $(this).addClass('active');
			carousel.trigger('carousel-next-complete', [index]);
            galeryPlay();
        });
      
      	if(settings.overlayObj){
          settings.overlayObj.find('.item-overlay').fadeOut(800);
          settings.overlayObj.find('.overlay-'+(index+1)).fadeIn(800);
        }
      
      	if(settings.onChange) {
          settings.onChange(index);
        }
    };

    var galeryPlay = function(){
        clearInterval(intervalCarousel);
        intervalCarousel = setInterval(function(){
          next();
        }, settings.playtime);
    };

    var galeryPause = function(){
        clearInterval(intervalCarousel);
    };
	
	var initSlideMenu = function() {
		var itemsCount = carousel.find('.item').length;

		for(var i=0; i<itemsCount; i++) {
		  var active = (i==0 ? 'class="active"' : '');
			settings.slidemenu.append('<li href="#'+i+'" '+active+'></li>');
		}

		settings.slidemenu.find('li').click(function(){
			galeryGoTo($(this).index());
			return false;
		});

		carousel.on('carousel-next-complete', function(event, nextIndex){
			settings.slidemenu.find('li.active').removeClass('active');
            settings.slidemenu.find('li:eq('+nextIndex+')').addClass('active');
          
      		if(settings.afterChange) {
      			settings.afterChange(nextIndex);
      		}
		});
	};
  
  	var next = function(){
  		var active = carousel.find('.item.active');
        var currentIndex = carousel.find('.item').index(active);
        var nextIndex = carousel.find('.item').length==(currentIndex+1) ? 0 : (currentIndex+1);

        galeryGoTo(nextIndex);
  	};

	var init = function() {
		
		carousel.find('a.next').click(function(){
			next();
		});

		carousel.find('a.prev').click(function(){
			var active = carousel.find('.item.active');
			var currentIndex = carousel.find('.item').index(active);
			var nextIndex = currentIndex==0 ? (carousel.find('.item').length-1) : (currentIndex-1);

			galeryGoTo(nextIndex);
		});

		if(settings.slidemenu) {
			initSlideMenu();
		}
		galeryPlay();
      
      	if(settings.afterInit) {
			settings.afterInit();
		}
		
		return carousel;
	}

	return init();
};